const TimelineEntry = ({ date, newDate, title, isExtended }) => {
  return (
    <div className="relative pl-10 sm:pl-12 py-3 md:py-4 group">
      <div className="flex flex-row items-start gap-6 group-last:before:hidden before:absolute before:left-3 before:h-full before:w-px before:bg-slate-300 before:self-start before:-translate-x-1/2 before:translate-y-3 after:absolute after:left-3 after:w-3 after:h-3 after:bg-indigo-600 after:border-4 after:box-content after:border-slate-50 after:rounded-full after:-translate-x-1/2 after:translate-y-1.5">
        <div className="translate-y-0.5 inline-flex flex-col items-start justify-center w-[170px] sm:w-[130px] flex-shrink-0">
          <time
            className={`text-sm font-bold uppercase w-full h-7 mb-1 sm:mb-0 whitespace-nowrap text-center ${
              isExtended ? "line-through text-red-600" : "text-emerald-600"
            } bg-emerald-100 rounded-full`}
          >
            {date}
          </time>
          {isExtended && (
            <time className="text-sm font-bold uppercase w-full h-7 mb-3 sm:mb-0 whitespace-nowrap text-center text-emerald-600 bg-emerald-100 rounded-full">
              {newDate}
            </time>
          )}
        </div>
        <div className="text-xl font-[600] text-blue_super_dark leading-tight">
          {title}
        </div>
      </div>
    </div>
  );
};

export const Timeline = () => {
  const timelineEvents = [
    {
      date: "31 January 2026",
      newDate: "10 February 2026",
      title: "Deadline for Full paper submissions (Hard Deadline)",
      isExtended: true,
    },
    {
      date: "03 March 2026",
      // newDate: "12 Nov 2026",
      title: "Acceptance / Rejection Notification",
      isExtended: false,
    },
    {
      date: "10 March 2026",
      title: "Deadline for registration",
      isExtended: false,
    },
    { date: "19-20 March 2026", title: "Conference Date", isExtended: false },
  ];

  return (
    <div className="my-2 mx-4 mb-8">
      {timelineEvents.map((event, index) => (
        <TimelineEntry
          key={index}
          date={event.date}
          newDate={event.newDate}
          title={event.title}
          isExtended={event.isExtended}
        />
      ))}
    </div>
  );
};
